import { render, staticRenderFns } from "./OrderService.vue?vue&type=template&id=13ceb1f6&"
import script from "./OrderService.vue?vue&type=script&lang=js&"
export * from "./OrderService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports